const IrrigationIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M7 10v12" />
    <path d="M15 5.88V22" />
    <path d="M10.74 3a2 2 0 1 1 2.52 0" />
    <path d="M12 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" />
    <path d="M7 10a5 5 0 0 1 10 0" />
  </svg>
);

export default IrrigationIcon;
